import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69ac68e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "serviceClause"
}
const _hoisted_2 = {
  key: 0,
  src: "https://dec-install.oss-cn-beijing.aliyuncs.com/DECHubTermsOfService.pdf",
  frameborder: "0"
}
const _hoisted_3 = {
  key: 1,
  src: "https://dec-100.oss-cn-beijing.aliyuncs.com/DECHubTermsOfServiceEN.pdf",
  frameborder: "0"
}
const _hoisted_4 = ["src"]

import { computed } from "vue";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceClause',
  setup(__props) {

const appLanguage: any = computed(() => store.getters.getAppLanguage);
const isMobile = store.state.isMobile;
const agreementMobileUrl = {
  zh: require("@/assets/mobile-images/servises/DECHubTermsOfServiceZH.jpg"),
  en: require("@/assets/mobile-images/servises/DECHubTermsOfServiceEN.jpg"),
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(appLanguage) === 'zh')
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_2))
          : (_openBlock(), _createElementBlock("iframe", _hoisted_3))
      ]))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: agreementMobileUrl[_unref(appLanguage) as 'zh'|'en'],
        alt: "",
        class: "image"
      }, null, 8, _hoisted_4))
}
}

})